"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require("react-bootstrap");

var _styled = require("../styled.form");

var _gridFormProps = require("./gridFormProps");

var _gridFormProps2 = _interopRequireDefault(_gridFormProps);

var _baseHelper = require("../../../helper/baseHelper");

var _baseHelper2 = _interopRequireDefault(_baseHelper);

var _inlineDiv = require("../../../inlineDiv");

var _inlineDiv2 = _interopRequireDefault(_inlineDiv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var getPropValue = _baseHelper2.default.getPropValue;


var GetInlineInput = function GetInlineInput(inputProp) {
  return _react2.default.createElement(
    _reactBootstrap.Col,
    { md: 6 },
    _react2.default.createElement(
      _reactBootstrap.Form.Group,
      null,
      _react2.default.createElement(_styled.StyledInput, _extends({
        type: inputProp.type,
        name: inputProp.name
      }, inputProp.inputStyleProps, {
        onChange: function onChange(e) {
          var value = e.target.value;
          inputProp.setState(value);
        },
        value: inputProp.value,
        placeholder: inputProp.placeholder,
        required: true
      }))
    )
  );
};

var Inline = function Inline(inline) {
  return _react2.default.createElement(_inlineDiv2.default, {
    isEditMode: inline.isEditMode,
    keyProperty: inline.keyProperty,
    property: "content",
    setData: inline.setData,
    updateProps: inline.updateProps,
    value: inline.value
  });
};

var GridForm = function GridForm(props) {
  var _useState = (0, _react.useState)(""),
      _useState2 = _slicedToArray(_useState, 2),
      fullName = _useState2[0],
      setFullName = _useState2[1];

  var _useState3 = (0, _react.useState)(""),
      _useState4 = _slicedToArray(_useState3, 2),
      email = _useState4[0],
      setEmail = _useState4[1];

  var _useState5 = (0, _react.useState)(""),
      _useState6 = _slicedToArray(_useState5, 2),
      phone = _useState6[0],
      setPhone = _useState6[1];

  var _useState7 = (0, _react.useState)(""),
      _useState8 = _slicedToArray(_useState7, 2),
      city = _useState8[0],
      setCity = _useState8[1];

  var _useState9 = (0, _react.useState)(""),
      _useState10 = _slicedToArray(_useState9, 2),
      message = _useState10[0],
      setMessage = _useState10[1];

  var _useState11 = (0, _react.useState)(false),
      _useState12 = _slicedToArray(_useState11, 2),
      isLoading = _useState12[0],
      setLoading = _useState12[1];

  var _useState13 = (0, _react.useState)(true),
      _useState14 = _slicedToArray(_useState13, 2),
      show = _useState14[0],
      setShow = _useState14[1];

  var _useState15 = (0, _react.useState)(false),
      _useState16 = _slicedToArray(_useState15, 2),
      error = _useState16[0],
      setError = _useState16[1];

  var newProps = _extends({}, _gridFormProps2.default.props, props);
  var style = newProps.style,
      content = newProps.content,
      isEditMode = newProps.isEditMode,
      setData = newProps.setData,
      updateProps = newProps.updateProps,
      onSubmitCallback = newProps.onSubmitCallback;


  var formWrapperProps = {
    bodycolor: getPropValue("text", "bodycolor", style.bodycolor, "style"),
    background: getPropValue("text", "background", style.background, "style")
  };
  var container = getPropValue("text", "container", style.container, "style");

  var inputStyleProps = {
    background: getPropValue("text", "inputBg", style.inputBg, "style"),
    borderColor: getPropValue("text", "borderColor", style.borderColor, "style"),
    inputColor: getPropValue("text", "inputColor", style.inputColor, "style"),
    inputRadius: getPropValue("text", "inputRadius", style.inputRadius, "style"),
    fontSize: getPropValue("text", "inputFontSize", style.inputFontSize, "style"),
    placeholderFontSize: getPropValue("text", "placeholderFontSize", style.placeholderFontSize, "style"),
    placeholderColor: getPropValue("text", "placeholderColor", style.placeholderColor, "style")
  };

  var fullNamePlaceholder = getPropValue("text", "fullName", content.fullName, "content");
  var emailPlaceholder = getPropValue("text", "email", content.email, "content");
  var phonePlaceholder = getPropValue("text", "number", content.number, "content");
  var cityPlaceholder = getPropValue("text", "city", content.city, "content");
  var messagePlaceholder = getPropValue("text", "message", content.message, "content");

  var buttonProps = {
    buttonBg: getPropValue("text", "buttonBg", style.buttonBg, "style"),
    hoverBg: getPropValue("text", "buttonHoverBg", style.buttonHoverBg, "style"),
    color: getPropValue("text", "buttonColor", style.buttonColor, "style"),
    hoverColor: getPropValue("text", "buttonHoverColor", style.buttonHoverColor, "style"),
    btnRadius: getPropValue("text", "buttonRadius", style.buttonRadius, "style"),
    borderColor: getPropValue("text", "buttonBorderColor", style.buttonBorderColor, "style"),
    hoverBorderColor: getPropValue("text", "buttonHoverBorderColor", style.buttonHoverBorderColor, "style"),
    fontSize: getPropValue("text", "buttonFont", style.buttonFont, "style")
  };
  var formTitle = getPropValue("text", "formTitle", content.formTitle, "content");

  var buttonText = getPropValue("text", "button", content.button, "content");

  var onSubmit = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
      var data;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              e.preventDefault();
              _context.prev = 1;

              setLoading(true);
              data = {
                city: city,
                email: newProps.media.email,
                fullName: fullName,
                message: message,
                number: phone,
                senderEmail: email
              };
              _context.next = 6;
              return onSubmitCallback(data);

            case 6:
              setFullName("");
              setEmail("");
              setPhone("");
              setCity("");
              setMessage("");
              setLoading(false);
              setShow(false);
              _context.next = 21;
              break;

            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](1);

              setShow(true);
              setError(true);
              setLoading(false);
              console.log("Error", _context.t0);

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, undefined, [[1, 15]]);
    }));

    return function onSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var inputs = [{
    type: "text",
    name: "fullName",
    setState: setFullName,
    value: fullName,
    placeholder: fullNamePlaceholder
  }, {
    type: "email",
    name: "email",
    setState: setEmail,
    value: email,
    placeholder: emailPlaceholder
  }, {
    type: "number",
    name: "number",
    setState: setPhone,
    value: phone,
    placeholder: phonePlaceholder
  }, {
    type: "text",
    name: "city",
    setState: setCity,
    value: city,
    placeholder: cityPlaceholder
  }];

  return _react2.default.createElement(
    _styled.FormWrapper,
    _extends({
      fluid: container,
      className: "form-wrapper position-relative p-4 p-md-5 mb-4"
    }, formWrapperProps),
    _react2.default.createElement(
      "div",
      { className: "form-wrapper " + (container ? "container px-0" : "") },
      _react2.default.createElement(
        "h2",
        { className: "" + (formTitle ? "mb-4 mb-md-5" : "mb-0") },
        _react2.default.createElement(_inlineDiv2.default, {
          isEditMode: isEditMode,
          keyProperty: "formTitle",
          property: "content",
          setData: setData,
          updateProps: updateProps,
          value: formTitle
        })
      ),
      _react2.default.createElement(
        _reactBootstrap.Form,
        null,
        _react2.default.createElement(
          _reactBootstrap.Form.Row,
          { className: "justify-content-between" },
          inputs.map(function (input) {
            return _react2.default.createElement(GetInlineInput, {
              type: input.type,
              name: input.name,
              inputStyleProps: inputStyleProps,
              setState: input.setState,
              value: input.value,
              placeholder: input.placeholder
            });
          })
        ),
        _react2.default.createElement(
          _reactBootstrap.Form.Group,
          { controlId: "formBlog", className: "w-100" },
          _react2.default.createElement(_styled.TextArea, _extends({
            rows: "3",
            type: "text",
            name: "message",
            className: "mb-2"
          }, inputStyleProps, {
            value: message,
            placeholder: messagePlaceholder,
            onChange: function onChange(e) {
              return setMessage(e.target.value);
            },
            required: true
          }))
        ),
        _react2.default.createElement(
          _styled.Button,
          _extends({}, buttonProps, { onClick: onSubmit }),
          isLoading ? _react2.default.createElement(_reactBootstrap.Spinner, { as: "span",
            animation: "border",
            size: "sm",
            role: "status",
            "aria-hidden": "true" }) : buttonText
        ),
        show && _react2.default.createElement(
          _reactBootstrap.Toast,
          { onClose: function onClose() {
              return setShow(false);
            }, className: "position-absolute " + (error ? "bg-danger" : "bg-success") + " mx-auto", show: show, delay: 3000, autohide: true },
          _react2.default.createElement(
            _reactBootstrap.Toast.Body,
            { className: "text-white" },
            error ? "Something went wrong" : "Form submitted successfully"
          )
        )
      )
    )
  );
};
exports.default = _react2.default.memo(GridForm);